import { useState } from "react";
import { useTranslation } from "react-i18next";
import villaPoolGarden from "@/assets/villa-pool-garden-upload.png?format=webp&w=1672&quality=90";
import villaPoolGardenSrcset from "@/assets/villa-pool-garden-upload.png?format=webp&w=480;768;1024;1280;1672&quality=85&as=srcset";
import villaPoolGardenFull from "@/assets/villa-pool-garden-upload.png";
import villaStreetView from "@/assets/villa-street-view.png?format=webp&w=1920&quality=92";
import villaStreetViewSrcset from "@/assets/villa-street-view.png?format=webp&w=480;768;1024;1280;1600;1920&quality=85&as=srcset";
import villaStreetViewFull from "@/assets/villa-street-view.png";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import ZoomableImage from "@/components/ZoomableImage";
const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState<{ src: string; altKey: string } | null>(null);
  const { t } = useTranslation();
  
  const images = [
    { src: villaPoolGarden, srcSet: villaPoolGardenSrcset, fullSrc: villaPoolGardenFull, altKey: "gallery.images.villaFront", captionKey: "captions.poolPositioning", width: 1920, height: 1080 },
    { src: villaStreetView, srcSet: villaStreetViewSrcset, fullSrc: villaStreetViewFull, altKey: "gallery.images.villaFront", captionKey: "captions.propertyView", width: 1920, height: 1280 },
  ];

  return (
    <section id="gallery" className="pt-10 md:pt-16 lg:pt-20 pb-4 md:pb-4 bg-secondary/30">
      <div className="container mx-auto px-4 md:px-6 lg:px-12">

        <div className="flex flex-col gap-4 md:gap-8 max-w-4xl mx-auto">
          {images.map((image, index) => (
            <div key={index}>
              <div
                className="group relative overflow-hidden shadow-subtle hover:shadow-elegant transition-elegant cursor-pointer"
                onClick={() => setSelectedImage({ src: image.fullSrc, altKey: image.altKey })}
              >
                <img
                  src={image.src}
                  srcSet={image.srcSet}
                  sizes="(max-width: 768px) 100vw, min(896px, 100vw)"
                  alt={t(image.altKey)}
                  loading={index === 0 ? "eager" : "lazy"}
                  fetchPriority={index === 0 ? "high" : undefined}
                  decoding={index === 0 ? "sync" : "async"}
                  width={image.width}
                  height={image.height}
                  className="w-full h-auto md:h-[600px] object-contain bg-secondary/30 group-hover:scale-[1.02] transition-elegant"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/50 via-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-elegant" />
              </div>
              {image.captionKey && (
                <p className="font-body text-sm md:text-base text-foreground/70 italic text-center mt-2 md:mt-3 px-2">
                  {t(image.captionKey)}
                </p>
              )}
            </div>
          ))}
        </div>

        <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
          <DialogContent className="max-w-7xl w-[95vw] h-[90vh] p-0 overflow-hidden">
            {selectedImage && (
              <div className="relative w-full h-full bg-background">
                <ZoomableImage
                  src={selectedImage.src}
                  alt={t(selectedImage.altKey)}
                />
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default Gallery;